/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import { queryString } from '@utils/format';

export const actions = {
  async fetch({}, payload) {
    const url = `/settlement?${queryString(payload.params)}`;
    return await http.get(url).then(({ data }) => data);
  },

  download({}, payload) {
    const params = (payload && payload.params) || {};
    const url = process.env.VUE_APP_API_URL + `/settlement/download?${queryString(params)}`;
    return url;
  },

  downloadDetail({}, payload) {
    const id = payload && payload.id ? payload.id : payload;
    return process.env.VUE_APP_API_URL + `/settlement/${id}/download`;
  },

  detail({}, payload) {
    const id = payload && payload.id ? payload.id : payload;
    const params = (payload && payload.params) || {};
    const url = `/settlement/${id}?${queryString(params)}`;
    return http.get(url).then(({ data }) => data);
  },

  create({}, payload) {
    const url = `/settlement`;
    return http.post(url, payload.params);
  },

  update({}, payload) {
    const url = `/settlement/${payload.id}`;
    return http.patch(url, payload.params);
  },

  delete({}, payload) {
    const url = `/settlement/${payload.id}`;
    return http.delete(url);
  },

  upload({}, payload) {
    const url = `/settlement/upload`;
    return http.post(url, payload, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
};
